const {Component} = require("react");
const router = require("app/services/router");

class MobileSearch extends Component {

	empty() {
		this.inputElement.value = "";
		return this;
	}

	focus() {

    }

	render() {
		return (
			<form action={router.route("search.query")}>
				<input ref={el => this.inputElement = el} name="q" type="search" placeholder={ translate("Hvad søger du?") }/>
				<input type="submit" value={ translate("Søg")}/>
			</form>
		);
	}

}

module.exports = MobileSearch;
